/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Thanks_TitleInputs */

const en_us2_workout_after_thanks_title = /** @type {(inputs: Workout_After_Thanks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you!`)
};

const pt_br2_workout_after_thanks_title = /** @type {(inputs: Workout_After_Thanks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigado!`)
};

const es_419_workout_after_thanks_title = /** @type {(inputs: Workout_After_Thanks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Gracias!`)
};

const pt_pt2_workout_after_thanks_title = /** @type {(inputs: Workout_After_Thanks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigado!`)
};

const fr_fr2_workout_after_thanks_title = /** @type {(inputs: Workout_After_Thanks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merci !`)
};

const de_de2_workout_after_thanks_title = /** @type {(inputs: Workout_After_Thanks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danke!`)
};

const it_it2_workout_after_thanks_title = /** @type {(inputs: Workout_After_Thanks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grazie!`)
};

/**
* | output |
* | --- |
* | "Thank you!" |
*
* @param {Workout_After_Thanks_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_thanks_title = /** @type {((inputs?: Workout_After_Thanks_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Thanks_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_thanks_title(inputs)
	if (locale === "es-419") return es_419_workout_after_thanks_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_thanks_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_thanks_title(inputs)
	if (locale === "de-DE") return de_de2_workout_after_thanks_title(inputs)
	if (locale === "it-IT") return it_it2_workout_after_thanks_title(inputs)
	return en_us2_workout_after_thanks_title(inputs)
});
export { workout_after_thanks_title as "workout-after.thanks_title" }